var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8234CB98-67DA-4A3C-B814-08980BD9D3B6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03_Web_Provider",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web_provider_Home-Dashboard-Patients",
    transform: "translate(-485.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(240.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(245.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#0CD0A7",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: 72648,
    transform: "translate(10.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07168889,12.1646275 C12.4230167,12.1644314 13.6288444,8.78066667 13.9445056,6.00113725 C14.3333556,2.57705882 12.7276333,0 9.07168889,0 C5.41621111,0 3.80967222,2.57686275 4.19883333,6.00113725 C4.51480556,8.78066667 5.72028333,12.1648627 9.07168889,12.1646275 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3997167,13.5731373 C16.5075556,13.5731373 16.6146944,13.5763922 16.7210944,13.5823529 C16.5616111,13.3529412 16.3770056,13.1505882 16.1609778,12.9879216 C15.5170167,12.5032549 14.6830056,12.3442353 13.9457111,12.0520784 C13.5868056,11.9099216 13.2654278,11.7687059 12.9637278,11.6079216 C11.9454611,12.734 10.6176,13.3230588 9.0713,13.3232157 C7.52550556,13.3232157 6.19776111,12.7341569 5.17961111,11.6079216 C4.87791111,11.7687451 4.55645556,11.9099216 4.19762778,12.0520784 C3.46033333,12.3442745 2.62636111,12.5032549 1.98236111,12.9879216 C0.868661111,13.8261569 0.580844444,15.7118431 0.354705556,16.9981176 C0.168077778,18.0599216 0.0427,19.1434902 0.00610555556,20.222 C-0.0222444444,21.0574118 0.386788889,21.174549 1.07986667,21.4267451 C1.94767222,21.7423529 2.84371111,21.9766667 3.74577778,22.1687451 C5.48788333,22.5397255 7.28361667,22.8247843 9.07161111,22.8375294 C9.93797778,22.8312941 10.8060944,22.7608235 11.6690778,22.648 C11.0300944,21.7143922 10.6553222,20.5834902 10.6553222,19.3658431 C10.6553611,16.1716863 13.2322556,13.5731373 16.3997167,13.5731373 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3997167,14.7316863 C13.86175,14.7316863 11.8041778,16.806549 11.8041778,19.3658431 C11.8041778,21.9251373 13.8617111,24 16.3997167,24 C18.9377222,24 20.9952944,21.9251373 20.9952944,19.3658431 C20.9952944,16.8065098 18.9376833,14.7316863 16.3997167,14.7316863 Z M18.4102722,20.160902 L17.1881889,20.160902 L17.1881889,21.3932157 C17.1881889,21.8323529 16.8351944,22.1883529 16.3997556,22.1883529 C15.9642778,22.1883529 15.6112444,21.8323529 15.6112444,21.3932157 L15.6112444,20.160902 L14.3892,20.160902 C13.9537222,20.160902 13.6006889,19.8049412 13.6006889,19.3657647 C13.6006889,18.9266275 13.9536833,18.5706275 14.3892,18.5706275 L15.6112444,18.5706275 L15.6112444,17.3383137 C15.6112444,16.8991765 15.9642778,16.5431765 16.3997556,16.5431765 C16.8352333,16.5431765 17.1881889,16.8991765 17.1881889,17.3383137 L17.1881889,18.5706275 L18.4102722,18.5706275 C18.84575,18.5706275 19.1987833,18.9266275 19.1987833,19.3657647 C19.1987833,19.8049804 18.8457889,20.160902 18.4102722,20.160902 Z",
    id: "Shape"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval);
export default ForwardRef;